<template>
    <vue-custom-scrollbar>
        <div class="card-body bg-white p-4 text-center d-flex justify-content-center flex-column flex-wrap">
            <div>
                <img
                    class="sample-image"
                    :src="getSampleEventImage()"
                    alt
                />
            </div>
            <h2 class="mb-0 mt-2">{{ $t("Crea un nuovo evento") }}</h2>
            <div class="mt-2">
                <button
                    class="pulsante-crea-gallery btn btn-primary btn-rikorda1"
                    @click="goToGalleries"
                >{{ $t("Crea") }}</button>
            </div>
        </div>
    </vue-custom-scrollbar>
</template>

<script>
import vueCustomScrollbar from "vue-custom-scrollbar";
export default {
    name: "BackendDashboardBoxCreaGallery",
    components: { vueCustomScrollbar },
    methods: {
        goToGalleries() {
            this.$router.push({ name: "backend-galleries" });
        },
        getSampleEventImage() {
            var imageId = process.env.VUE_APP_WATERMARKS_SAMPLE_IMAGE_H;
            var url =
                process.env.VUE_APP_API_BASE_URL +
                "viewImage.php?id=" +
                imageId +
                "&type=web";
            return url;
        }
    }
};
</script>

<style scoped>
section,
div.card-body {
    height: 100%;
}
img.sample-image {
    max-width: 60%;
    max-height: 100%;
}
</style>
